import React, { FC } from 'react';
import { Modal } from 'antd';
import { ReactComponent as RemoveAlertSVG } from 'src/assets/images/onboarding-trainer/subscription-icons/remove-payment-method/remove-alert.svg';
import { ReactComponent as UserChevronLeftSVG } from 'src/assets/images/onboarding-trainer/components/sidebar/user-chevron-left.svg';
import './SubscriptionModals.scss';

interface RemovePaymentMethodModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirmRemove: () => void;
}

export const RemovePaymentMethodModal: FC<RemovePaymentMethodModalProps> = ({
  isOpen,
  onClose,
  onConfirmRemove,
}) => {
  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      centered
      width={420}
      closeIcon={null}
      rootClassName="subscription-modal-wrapper"
      styles={{
        mask: {
          backdropFilter: 'blur(8px)',
          backgroundColor: 'rgba(6, 7, 35, 0.75)',
        },
      }}
    >
      <div className="remove-card-modal-content">
        <div className="trash-icon-wrap">
          <RemoveAlertSVG />
        </div>

        <h2>{'Are you sure you want to remove the card?'}</h2>

        <div className="remove-actions">
          <button
            type="button"
            className="btn-confirm-remove"
            onClick={() => {
              onConfirmRemove();
              onClose();
            }}
          >
            {'Yes, remove card'}
          </button>
          <button type="button" className="btn-back-manage" onClick={onClose}>
            <UserChevronLeftSVG />
            <span>{'Back to Manage Payments'}</span>
          </button>
        </div>
      </div>
    </Modal>
  );
};
